export default {
  time_options: {
    asap: {
      title: 'ASAP',
      description: 'Ready in {{time}} min',
    },
    scheduled: {
      title: 'Schedule for later',
    },
  },
};
